import { Component, Input, OnDestroy , OnInit } from '@angular/core';
import { UserDetailedInterface, UserInterface } from 'app/core/user/models';
import { TaskInterface } from 'app/task/models/task.model';
import { BehaviorSubject, combineLatest,  Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormControl } from '@angular/forms';

import { AppScopes } from 'app/core/authentication/models/scopes.enum';
import { AuthService } from 'app/core/authentication/services';
@Component({
  selector: 'cz-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
})
export class TasksComponent implements OnInit, OnDestroy {

  @Input() public tasksCompletedForUser$: BehaviorSubject<Readonly<TaskInterface[]>>;
  @Input() public tasksCompletedByUser$: BehaviorSubject<Readonly<TaskInterface[]>>;
  @Input() public tasksOpenAndAssignedToUser$: BehaviorSubject<TaskInterface[]>;
  @Input() public tasksOpenAndTheSubjectIsUser$: BehaviorSubject<Readonly<TaskInterface[]>>;
  @Input() public taskUser: UserDetailedInterface;
  @Input() public selectedAccordionIndex: number;
  @Input() public userDetailView: boolean;

  public closedForTaskCount: number = 9;
  public closedByTaskCount: number = 9;
  public readonly loadMoreIncrement: number = 9;


  public employeeSearchControl: FormControl;
  public filterTasksList:TaskInterface[] = [];
  public openTaskCount:any;
  public isAdmin: boolean;
  private scopeResults: {[id: string]: boolean};
  private loggedInUser: UserInterface;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private _authService: AuthService) {
    this.employeeSearchControl = new FormControl('');
  }

  public ngOnInit():void {
    combineLatest(
      this._authService.isLoggedInUserAuthorizedSet([
        AppScopes.CASE_MANAGEMENT_MASTER,
      ]),
      this._authService.getAuthenticatedUser(),
    ).pipe(takeUntil(this.destroy$))
    .subscribe((data: [{[id: string]: boolean}, UserInterface]) => {
      if(data[0]) {
        this.scopeResults = data[0];
      }

      if(data[1]) {
        this.loggedInUser = data[1];
      }
      if(this.scopeResults && this.loggedInUser) {
        this.isAdmin = this.scopeResults[AppScopes.CASE_MANAGEMENT_MASTER];
      }
    });

    this.employeeSearchControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.tasksFilterData();
      });

  }

  public get allShownFor(): boolean {
    const total: number = this.tasksCompletedForUser$.value.length;
    return total <= this.closedForTaskCount;
  }

  public getVisibleCompletedForTasks(): number {
    return this.tasksCompletedForUser$.value.length;
  }

  public loadMoreClosedForTasks(): void {
    this.closedForTaskCount += this.loadMoreIncrement;
  }

  public get allShownBy(): boolean {
    const total: number = this.tasksCompletedByUser$.value.length;
    return total <= this.closedByTaskCount;
  }

  public getVisibleCompletedByTasks(): number {
    return this.tasksCompletedByUser$.value.length;
  }

  public loadMoreClosedByTasks(): void {
    this.closedByTaskCount += this.loadMoreIncrement;
  }

  public taskOverdue(tasks: TaskInterface[]): boolean {
    let overdue: boolean = false;
    if (!tasks || tasks.length < 1) { return overdue; }

    tasks.forEach((task: TaskInterface) => {
      if (task.isOverDue) { overdue = true; }
    });
    return overdue;
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private tasksFilterData(): void {
    this.filterTasksList= this.tasksOpenAndAssignedToUser$.value.filter((tasks: TaskInterface) => {
      // tslint:disable-next-line:max-line-length
      if(tasks.subject.firstName.toLowerCase().indexOf(this.employeeSearchControl.value.toLowerCase()) >= 0 || tasks.subject.lastName.toLowerCase().indexOf(this.employeeSearchControl.value.toLowerCase()) >= 0 || tasks.subject.userName.toLowerCase().indexOf(this.employeeSearchControl.value.toLowerCase()) >= 0) {

        return tasks;
      }

    });

  }
  // tslint:disable-next-line:typedef
  public get openTasksList() {

    if(this.filterTasksList.length>0|| this.employeeSearchControl.value.trim()!=='') {
      return this.filterTasksList;
    }
    this.openTaskCount= this.tasksOpenAndAssignedToUser$.value.length;
    return this.tasksOpenAndAssignedToUser$.value;



  }
}
